var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{attrs:{"action":"aaa","show-file-list":true,"file-list":_vm.playUrls,"http-request":_vm.uploadSectionFile,"on-remove":_vm.onRemove}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }